import { toChinaDateString } from "./chinaDate";

export default function calculatePaymentDue({
  terms,
  shippingDate,
  invoicingDate,
}) {
  const shippingTime = shippingDate ? new Date(shippingDate).getTime() : 0;
  const paymentDue =
    Math.max(shippingTime, new Date(invoicingDate).getTime()) +
    terms * 86400000;

  return toChinaDateString(paymentDue);
}
